import React from "react";
import NavBar from "./NavBar";
import UserSideBar from "./UserSideBar";
import Form from "react-bootstrap/Form";
import { useSelector } from "react-redux";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import "./accountDetails.css";

function AccountDetails() {
  const user = useSelector((state) => state.user);
  return (
    <>
      <NavBar />
      <div style={{ marginTop: "7rem" }} className="container mb-5">
        <div className="row">
          <div className="col-8 col-lg-3 mb-5">
            <UserSideBar />
          </div>
          <div className="col-12 p-0 col-lg-9 d-flex justify-content-center">
            <div className="border p-4 personal-form">
              <Form className="text-start">
                <h3 className="mb-3">Personal Information</h3>
                <Row className="mb-3">
                  <Form.Group as={Col}>
                    <Form.Label>Firstname</Form.Label>
                    <Form.Control type="text" readOnly value={user.firstName} />
                  </Form.Group>

                  <Form.Group as={Col}>
                    <Form.Label>Lastname</Form.Label>
                    <Form.Control type="text" readOnly value={user.lastName} />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mb-3">
                    <Form.Label>Address</Form.Label>
                    <Form.Control type="text" readOnly value={user.address} />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Phone</Form.Label>
                    <Form.Control type="text" readOnly value={user.phone} />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control type="text" readOnly value={user.email} />
                  </Form.Group>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AccountDetails;
